<template>
  <v-dialog :value="value" width="500" persistent>
    <v-card>
      <v-card-title>Fault Appointment</v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-select v-model="formData.time" :items="['AM','PM']" label="Preferred engineer appointment time" :disabled="getIsProductLoading" dense outlined hide-details />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <DateSelect v-model="formData.date" label="Appointment Date" :disabled="getIsProductLoading" :min="minDate"/>
          </v-col>
          <v-col>
            <v-text-field v-model="formData.reference" label="Appointment Reference" :disabled="getIsProductLoading" dense outlined hide-details />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" small :disabled="getIsProductLoading" :loading="getIsProductLoading" @click="submit">SAVE</v-btn>
        <v-btn color="primary" small outlined :disabled="getIsProductLoading" @click="close">CLOSE</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapGetters,mapActions,mapMutations} from 'vuex';
  import moment from "moment";
  import DateSelect from '@/components/Globals/DateSelect.vue';

  export default {

    props: ['value'],

    components: { DateSelect },

    data() {
      return {
        formData: {
          time: '',
          date: '',
          reference: '',
        },
        minDate: this.$options.filters.formatDate(moment().add(1, 'days'), 'YYYY-MM-DD'),
      }
    },

    computed: {
      ...mapGetters('products', ['getCurrentProduct']),
      ...mapGetters('productGeneral', ['getIsProductLoading','getProductError']),
    },

    watch: {
      value(open) {
        if(open){
          this.formData.time = this.getCurrentProduct.product_details.fault_appt_preferred_window;
          this.formData.date = this.getCurrentProduct.product_details.fault_appt_date;
          this.formData.reference = this.getCurrentProduct.product_details.fault_appt_ref;
        }
      }
    },

    methods: {
      ...mapActions('productGeneral',['updateTelcoProduct']),
      ...mapMutations('products',['UPDATE_FAULT_APPOINTMENT']),

      async submit() {
        const data = {
          product_id: this.$route.params.id,
          data: {
            fault_appt_preferred_window: this.formData.time,
            fault_appt_date: this.formData.date,
            fault_appt_ref: this.formData.reference,
          },
          success: 'Fault appointment updated successfully',
        };
        await this.updateTelcoProduct(data);
        if(!this.getProductError){
          this.UPDATE_FAULT_APPOINTMENT(data.data);
          this.close();
        }
      },

      close() {
        this.$emit('input', false);
      },
    },

  }
</script>

<style lang="scss" scoped></style>
